import { Button } from "flowbite-react";
import { useNavigate } from "react-router-dom";

const CTASection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-24 px-6 sm:px-12 bg-gradient-to-r from-[#fff1be] via-[#ee87cb] to-[#b060ff] text-gray-900">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-gray-900">
          Pronta para organizar sua vitrine?
        </h2>
        <p className="mt-6 text-lg leading-8 text-gray-800/90">
          Cadastre seus primeiros produtos gratuitamente e tenha um link fácil de
          compartilhar com suas clientes.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            size="lg"
            pill
            onClick={() => navigate("/cadastrar")}
            className="bg-black text-white hover:bg-gray-800 w-full sm:w-auto"
          >
            Criar minha Vintree grátis
          </Button>
          <Button
            size="lg"
            pill
            gradientDuoTone="pinkToOrange"
            onClick={() => navigate("/loja_exemplo")}
            className="w-full sm:w-auto"
          >
            Ver Vintree de Exemplo
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
